import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class UnsavedChangesGuard implements CanDeactivate<CanComponentDeactivate> {
    canDeactivate(component: CanComponentDeactivate) {
        return component.canDeactivate();
    }
}

export interface CanComponentDeactivate {
    canDeactivate: () => Observable<boolean> | boolean;
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/guards/unsaved.changes.guard.ts